import { defa } from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/logTagsForm.jst.html';

/**
 * defa.views.LogTagsForm
 * A form to filter LogTags with.
 * @version 1.2.0
 */

const selectors   = {
	checkboxTags : '[data-input=log-tag]',
	containerTags: '[data-container=checkbox-array]',
};
const LogTagsForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template        : template,
	noEnterKeypress : true,
	noInitValidation: true,
	
	ui: {
		inputs: selectors.checkboxTags,
		tags  : selectors.containerTags,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view is rendered.
	 * @void
	 */
	onRender: function () {
		this.drawHtmlCheckboxes();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Draws checkboxes for every tag available to the log.
	 * @void
	 */
	drawHtmlCheckboxes: function () {
		
		let self     = this,
			html5    = '',
			template = '';
		
		template += '<div>';
		template +=     '<input type="checkbox" id="tag-%s-input" name="tag-input" data-input="log-tag" value="%s"%s>';
		template +=     '<label for="tag-%s-input">%s</label>';
		template += '</div>';
		
		_.each( defa.vars.logTags, function ( tag, index ) {
			
			let checked = ( _.indexOf( self.options.tags, tag.value ) !== -1 )
						  ? ' checked'
						  : '';
			
			html5 += template
				.replace( '%s', index )
				.replace( '%s', tag.value )
				.replace( '%s', checked )
				.replace( '%s', index )
				.replace( '%s', tag.term );
			
		} );
		
		self.ui.tags.html( html5 );
	},
	
	/**
	 * Triggers a submit event with all checked tags.
	 * @void
	 */
	submit: function () {
		
		let arrayTags = this.ui.tags.find( selectors.checkboxTags )
			.filter( ':checked' )
			.map( function () {
				return $( this ).val();
			} ).get();
		
		this.trigger( 'change:tags', arrayTags );
	},
	
} );

export default LogTagsForm;